import React, { useEffect, useState } from 'react';
// javascipt plugin for creating charts
import {
  Chart,
  Title,
  Tooltip,
  CategoryScale,
  LinearScale,
  BarElement,
} from 'chart.js';
// react plugin used to create charts
import { Bar } from 'react-chartjs-2';
// reactstrap components
import { round } from 'lodash-es';
import { parseOptions } from 'variables/charts';
import { chartOptions } from 'variables/charts';
// import { isFloat } from '../../../../utils/misc';
import { Card, CardBody, Spinner } from 'reactstrap';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { orderBy } from 'lodash';
import { useMonthwiseAnalyticsOfCorporate } from 'utils/queries/corporateAnalytics';
import { months } from 'utils/chartConstants';
parseOptions(Chart, chartOptions());
Chart.plugins.register(
  ChartDataLabels,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
);

export default function DashboardCorporateLevelAnalytics({ selectedYear }) {
  const {
    data: dailyData,
    isLoading,
    error,
  } = useMonthwiseAnalyticsOfCorporate(selectedYear);

  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    // if (dailyData?.list?.length > 0) {
    const sortedData = orderBy(dailyData?.list, ['MONTH'], ['asc']);
    const data = {
      labels: sortedData?.map((row, indx) => `${months[row?.MONTH - 1]}`),
      datasets: [
        {
          label: 'No. of Charging Sessions',
          data: sortedData?.map((row) => row?.CHARGING_SESSIONS),
          backgroundColor: '#9ac55d',
          color: '#ffffff',
          barThickness: 50,
          datalabels: {
            display: true,
            formatter: (value) => `${round(value, 2)}`,
            color: 'black',
            anchor: 'end',
            offset: -20,
            align: 'start',
          },
        },
        {
          label: 'Energy Consumed',
          data: sortedData?.map((row) => row?.KWH_DELIVERED),
          backgroundColor: '#1a7bbb',
          color: '#ffffff',
          barThickness: 50,
          datalabels: {
            display: true,
            formatter: (value) => `${round(value, 2)}Kwh`,
            font: { size: 12 },
            color: 'black',
            anchor: 'end',
            offset: -20,
            align: 'start',
            padding: { left: 20 },
          },
        },
      ],
    };

    setChartData(data);
    // }
  }, [dailyData]);

  if (isLoading) {
    <h1>Loading</h1>;
  }
  if (error) {
    <h1>Error</h1>;
  }

  const options = {
    title: {
      display: true,
      text: `Monthwise Analytics ${selectedYear}`,
      color: '#fff',
      position: 'bottom',
    },
    legend: {
      display: true,
    },
    scales: {
      xAxes: {
        grid: {
          display: false,
        },
      },
      yAxes: [
        {
          ticks: {
            display: false,
          },
        },
      ],
    },
    layout: {
      padding: {
        top: 15,
        left: 0,
        right: 0,
        bottom: 0,
      },
    },
    tooltips: {
      enabled: false,
    },
  };
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: '2px solid rgb(222, 222, 225)',
          borderRadius: '10px',
          boxShadow: 'rgb(222 222 225) 5px 5px',
        }}
      >
        {isLoading ? (
          <Spinner style={{ color: '#2675b8' }} />
        ) : error ? (
          'Oops something went wrong'
        ) : dailyData?.list?.lemgth === 0 || !selectedYear ? (
          <div
            style={{
              display: 'flex',
              height: '250px',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            We dont have any Analytics report
          </div>
        ) : (
          <Card style={{ width: '100%', height: '100%' }}>
            <CardBody>
              <div
                style={{
                  maxHeight: '300px',
                  minHeight: '300px',
                }}
              >
                {chartData?.datasets && dailyData?.list?.length !== 0 ? (
                  <Bar options={options} data={chartData} />
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      height: '300px',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    We dont have data for Monthwise Analytics
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        )}
      </div>
    </>
  );
}
